export const getAuth = (state) => state.auth;
export const getToken = (state) => state.auth.accessToken;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectUser = (state) => state.auth.user;
export const selectIsLoading = (state) => state.auth.loading;
export const selectError = (state) => state.auth.error;
export const selectIsRefreshing = (state) => state.auth.isRefreshing;
export const selectUsername = (state) => state.auth.user.username;
export const getCarts = (state) => state.auth.user.bucketProducts;
